import script from "./ListarPoliticasCobrancas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarPoliticasCobrancas.vue?vue&type=script&setup=true&lang=js"

import "./ListarPoliticasCobrancas.vue?vue&type=style&index=0&id=74e582fc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e582fc"]])

export default __exports__